"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SVGWheel = void 0;
var tslib_1 = require("tslib");
var normalize_wheel_1 = tslib_1.__importDefault(require("normalize-wheel"));
var PIXELS_PER_ZOOM = 240;
exports.SVGWheel = {
    /**
     * Milliseconds to wait between zoom ticks
     */
    DEBOUNCE_TIME: 40,
    getEventType: function () { return normalize_wheel_1.default.getEventType(); },
    delta: 0,
    startTime: 0,
    timer: 0,
    onWheel: function (dc, e) {
        var delta = (0, normalize_wheel_1.default)(e);
        exports.SVGWheel.delta += delta.pixelY;
        if (exports.SVGWheel.startTime === 0) {
            exports.SVGWheel.startTime = +new Date();
        }
        var left = Math.max(exports.SVGWheel.DEBOUNCE_TIME - (+new Date() - exports.SVGWheel.startTime), 0);
        clearTimeout(exports.SVGWheel.timer);
        exports.SVGWheel.timer = setTimeout(function (_) {
            // Use the leaflet method for calculating ZoomChange
            // https://github.com/Leaflet/Leaflet/blob/master/src/map/handler/Map.ScrollWheelZoom.js#L67
            // map the delta with a sigmoid function to -4..4 range leaning on -1..1
            var d2 = exports.SVGWheel.delta / (PIXELS_PER_ZOOM * 4);
            var d3 = 4 * Math.log(2 / (1 + Math.exp(-Math.abs(d2)))) / Math.LN2;
            var d4 = 1 + d3;
            var actualDelta = exports.SVGWheel.delta > 0 ? 1 / d4 : d4;
            dc.boundEvents.mousewheel(actualDelta, e);
            exports.SVGWheel.delta = 0;
        }, left);
        if (e.preventDefault) {
            e.preventDefault();
        }
        if (e.stopPropagation) {
            e.stopPropagation();
        }
    }
};
//# sourceMappingURL=svg.wheel.js.map